import EventsAdapter from './base';

export default class PermissionReply extends EventsAdapter {
  modelNamePlural = 'permissionReplies';
}
